import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import {  faCalendarWeek } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrl: './datepicker.component.scss',
    standalone: false
})
export class DatepickerComponent {
  @Input() maxDate: string = '';
  @Input() minDate: string = '';
  @Input() control: FormControl;
  @Input() value: string;
  @Input() borderColor   : string = '#5f6d7e';
  formattedDate: string = '';
  faCalendar = faCalendarWeek
  @Output() blur = new EventEmitter();

  openDatePicker(event: any) {
    this.control?.markAsTouched();
    setTimeout(() => {
      event.target.showPicker?.();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      const newValue = changes['value'].currentValue;
      if (newValue) {
        this.formattedDate = this.getFormattedDate(newValue);
      } else {
        this.formattedDate = '';
      }
    }
  }

  onDateChange(event: Event) {
    const dateValue = (event.target as HTMLInputElement).value;
    this.control?.setValue(dateValue);
    this.formattedDate = this.getFormattedDate(dateValue);
    this.control?.markAsDirty();
    this.control?.markAsTouched();
    this.control?.updateValueAndValidity();
  }
  
  getFormattedDate(rawDate: string): string {
    if (!rawDate) return '';
    return formatDate(rawDate, 'dd-MMM-yy', 'en-IN');
  }

  onBlur() {
    this.control?.markAsTouched();
    this.control?.updateValueAndValidity();
    this.blur.emit();
  }

}
